module.exports = __webpack_public_path__ + "img/MapsListBG.5fa2c8ec.webp";